// @ts-nocheck
/* eslint-disable */
const InputEvent = {
  Keyboard: 0,
  Mouse: 1,
  MouseWheel: 2,
  Touch: 3,
  Gamepad: 4,
  Click: 5,
  NoUnusedChannel: 6,
  JsonData: 7,
};

const KeyboardEventType = {
  Up: 0,
  Down: 1,
};

const Keymap = {
  Space: 1,
  Enter: 2,
  Tab: 3,
  Backquote: 4,
  Quote: 5,
  Semicolon: 6,
  Comma: 7,
  Period: 8,
  Slash: 9,
  Backslash: 10,
  BracketLeft: 11,
  BracketRight: 12,
  Minus: 13,
  Equal: 14,
  KeyA: 15,
  KeyB: 16,
  KeyC: 17,
  KeyD: 18,
  KeyE: 19,
  KeyF: 20,
  KeyG: 21,
  KeyH: 22,
  KeyI: 23,
  KeyJ: 24,
  KeyK: 25,
  KeyL: 26,
  KeyM: 27,
  KeyN: 28,
  KeyO: 29,
  KeyP: 30,
  KeyQ: 31,
  KeyR: 32,
  KeyS: 33,
  KeyT: 34,
  KeyU: 35,
  KeyV: 36,
  KeyW: 37,
  KeyX: 38,
  KeyY: 39,
  KeyZ: 40,
  Digit1: 41,
  Digit2: 42,
  Digit3: 43,
  Digit4: 44,
  Digit5: 45,
  Digit6: 46,
  Digit7: 47,
  Digit8: 48,
  Digit9: 49,
  Digit0: 50,
  ShiftLeft: 51,
  ShiftRight: 52,
  AltLeft: 53,
  AltRight: 54,
  ControlLeft: 55,
  ControlRight: 56,
  MetaLeft: 57,
  MetaRight: 58,
  ContextMenu: 59,
  Escape: 60,
  ArrowLeft: 61,
  ArrowRight: 62,
  ArrowUp: 63,
  ArrowDown: 64,
  Backspace: 65,
  PageDown: 66,
  PageUp: 67,
  Home: 68,
  End: 69,
  Insert: 70,
  Delete: 71,
  CapsLock: 72,
  NumLock: 73,
  PrintScreen: 74,
  ScrollLock: 75,
  Pause: 76,
  NumpadEnter: 77,
  NumpadDivide: 78,
  NumpadMultiply: 79,
  NumpadAdd: 80,
  NumpadSubtract: 81,
  NumpadDecimal: 82,
  NumpadEquals: 83,
  Numpad0: 84,
  Numpad1: 85,
  Numpad2: 86,
  Numpad3: 87,
  Numpad4: 88,
  Numpad5: 89,
  Numpad6: 90,
  Numpad7: 91,
  Numpad8: 92,
  Numpad9: 93,
  F1: 94,
  F2: 95,
  F3: 96,
  F4: 97,
  F5: 98,
  F6: 99,
  F7: 100,
  F8: 101,
  F9: 102,
  F10: 103,
  F11: 104,
  F12: 105,
};

const THREE_TO_UNITY = [
  48.566135255722138, 5.9039844991545219e-15, 26.589182390393496, 0, -26.589182390393496, 1.0783848315592456e-14,
  48.566135255722138, 0, 1.5056105662469236e-30, 55.368349387233039, -1.2294243265039259e-14, 0, 14304888.067458529,
  0.024668373420581702, 13763012.971616069, 1,
];

const Debug = false;

class RenderStreaming extends HTMLVideoElement {
  constructor() {
    super();

    window.ps = this;

    this.pc = { close() {} };
    this.ws = { send() {}, close() {} };
    this.channelInput = null;
    this.channelData = null;
    this.connectionId = null;
    this.localStream = new MediaStream();
    this.srcObject = this.localStream;

    this.polite = true;
    this.ignoreOffer = false;
    this.makingOffer = false;
    this.waitingAnswer = false;
    this.srdAnswerPending = false;
    this.interval = 5000;
    this.isClickingOutside = false;
    this.assert_equals = window.assert_equals
      ? window.assert_equals
      : (a, b, msg) => {
          if (a === b) {
            return;
          }
          throw new Error(`${msg} expected ${b} but got ${a}`);
        };
    this.sleep = msec => new Promise(resolve => setTimeout(resolve, msec));

    this.pending = new Map();
    this.lastSize = { width: 0, height: 0 };
    this.recreatingInput = false;
    this.recreatingData = false;
    this.videoFrameWatchTimer = null;
    this.lastInputAt = 0;
    this.lastVideoFrameCount = 0;
    this.lastVideoFrameChangedAt = Date.now();
    this.lastVideoFrameStallLogAt = 0;

    this.setupVideo();

    this.addEventListener(
      'loadedmetadata',
      () => {
        this.play();
        this.resizeVideo();
      },
      true
    );

    this.addEventListener('playing', () => {
      console.log('video playing');
      this.dispatchEvent(new CustomEvent('rs-video-ready'));
    });

    // setInterval(() => {
    // 	let rect = this.getBoundingClientRect();
    // 	console.log("width:" + rect.width + ",height:" + rect.height + ",videoWidth:" + this.videoWidth + ",videoHeight:" + this.videoHeight);
    // }, 1000);

    // document.addEventListener(
    // 	"pointerlockchange",
    // 	() => {
    // 		if (document.pointerLockElement === this) {
    // 			this.registerPointerLockEvents();
    // 		} else {
    // 			this.registerMouseHoverEvents();
    // 		}
    // 	},
    // 	false
    // );

    // this.addEventListener("loadeddata", (e) => {
    // 	this.style["aspect-ratio"] = this.videoWidth / this.videoHeight;
    // });
  }

  checkWebRTCSupport() {
    // Step 2: Check for RTCPeerConnection
    const RTCPeerConnection = window.RTCPeerConnection || window.webkitRTCPeerConnection || window.mozRTCPeerConnection;
    if (!RTCPeerConnection) {
      console.warn('checkWebRTCSupport RTCPeerConnection not supported');
      return false;
    }
    // Step 3: Check for DataChannel
    let dataChannelSupported = false;
    let pc = null;
    if (RTCPeerConnection) {
      try {
        pc = new RTCPeerConnection();
        const dc = pc.createDataChannel('test');
        dataChannelSupported = !!dc;
        dc.close(); // Close the DataChannel when done
        pc.close();
      } catch (e) {
        console.error(e);
        console.warn('checkWebRTCSupport dataChannelSupported not supported');
        return false;
      }
      if (!dataChannelSupported) {
        console.warn('checkWebRTCSupport DataChannel not supported');
        return false;
      }
    }
    return true;
  }

  resolveWebSocketUrl() {
    const websocketOrigin = location.protocol === 'https:' ? 'wss://' : 'ws://';
    const rs = this.getAttribute('rs');

    if (!rs) {
      return `${websocketOrigin}${location.host}${location.pathname}${location.search}`;
    }

    if (rs.startsWith('ws://') || rs.startsWith('wss://')) {
      return rs;
    }

    if (rs.startsWith('//')) {
      return `${websocketOrigin}${rs.slice(2)}`;
    }

    if (rs.startsWith('/')) {
      return `${websocketOrigin}${location.host}${rs}`;
    }

    return `${websocketOrigin}${rs}`;
  }

  async connectedCallback() {
    if (false == this.checkWebRTCSupport()) {
      const overlayDiv = document.createElement('div');
      overlayDiv.innerHTML = '你的浏览器版本过低!<br>推荐使用谷歌100以上版本浏览器!!';
      overlayDiv.style.position = 'absolute';
      overlayDiv.style.top = '50%';
      overlayDiv.style.left = '50%';
      overlayDiv.style.transform = 'translate(-50%, -50%)';
      overlayDiv.style.background = 'rgba(255, 255, 255, 0.8)';
      overlayDiv.style.padding = '10px';
      overlayDiv.style.borderRadius = '5px';
      overlayDiv.style.display = 'block'; // Initially hidden
      this.parentNode.appendChild(overlayDiv);
    }

    // This will happen each time the node is moved, and may happen before the element"s contents have been fully parsed. may be called once your element is no longer connected
    if (!this.isConnected) return;
    if (
      this.ws.readyState === 1 &&
      this.pc.connectionState === 'connected' &&
      this.channelInput &&
      this.channelInput.readyState === 'open' &&
      this.channelData &&
      this.channelData.readyState === 'open'
    ) {
      // this.pc.restartIce();
      this.play();
      return;
    }

    this.connectionId = this.safeUUID();

    await this.sleep(1000);
    this.ws.onclose = null;
    this.ws.close(1000);
    const url = this.resolveWebSocketUrl();
    this.ws = new WebSocket(url + '/' + this.connectionId, 'peer-stream');

    this.ws.onerror;

    this.ws.onopen = () => {
      console.info('✅', this.ws);
      this.registerKeyboardEvents();
      this.registerMouseEvents();
    };

    this.ws.onmessage = e => {
      this.onWebSocketMessage(e.data);
    };

    this.ws.onclose = async e => {
      console.warn(e);
      this.stopVideoFrameWatch();
      if (this.channelInput) this.channelInput.close();
      if (this.channelData) this.channelData.close();
      this.pc.close();
      this.unregisterKeyboardEvents();
      this.unregisterMouseEvents();
      this.connectionId = null;
      await this.sleep(3000);
      if (this.isConnected) this.connectedCallback();
    };

    this.setupPeerConnection();

    this.resizeVideoBind = this.resizeVideo.bind(this);
    this.resizeVideoBind2 = this.resizeVideo2.bind(this);
    this.mousedownCaptureBind = this.mousedownCapture.bind(this);
    this.mouseupCaptureBind = this.mouseupCapture.bind(this);

    window.addEventListener('resize', this.resizeVideoBind, true);
    window.visualViewport?.addEventListener('resize', this.resizeVideoBind, true);
    document.addEventListener('fullscreenchange', this.resizeVideoBind2, true);
    const _this = this;
    this.observer = new ResizeObserver(() => {
      _this.resizeVideoBind();
    });
    this.observer.observe(this);

    this.closeWindowBind = this.closeWindow.bind(this);
    window.removeEventListener('beforeunload', this.closeWindowBind);
    window.addEventListener('beforeunload', this.closeWindowBind);
  }

  disconnectedCallback() {
    // lifecycle binding
    // setTimeout(() => {
    if (this.isConnected) return;
    this.stopVideoFrameWatch();
    this.ws.close(1000);
    this.pc.close();
    console.log('❌ peer connection closing');

    window.removeEventListener('resize', this.resizeVideoBind, true);
    window.visualViewport?.removeEventListener('resize', this.resizeVideoBind, true);
    document.removeEventListener('fullscreenchange', this.resizeVideoBind2, true);
    window.removeEventListener('beforeunload', this.closeWindowBind);
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    // }, 5 * 1000);
  }

  adoptedCallback() {}

  attributeChangedCallback(name, oldValue, newValue) {
    if (!this.isConnected) return;
    // fired before connectedCallback when startup
    this.ws.close(1000);
  }

  updateVideoMetrics({ sendResize = false } = {}) {
    this.clientRect = this.getBoundingClientRect();
    const videoRatio = this.videoWidth / this.videoHeight;
    const clientRatio = Math.round(this.clientRect.width) / Math.round(this.clientRect.height);

    // this._videoScale = videoRatio > clientRatio ? this.clientRect.width / this.videoWidth : this.clientRect.height / this.videoHeight;
    // const videoOffsetX = videoRatio > clientRatio ? 0 : (this.clientRect.width - this.videoWidth * this._videoScale) * 0.5;
    // const videoOffsetY = videoRatio > clientRatio ? (this.clientRect.height - this.videoHeight * this._videoScale) * 0.5 : 0;
    // this._videoOriginX = this.clientRect.left + videoOffsetX;
    // this._videoOriginY = this.clientRect.top + videoOffsetY;

    this._videoScale2 = this.videoWidth / 3840;
    this._videoScale =
      videoRatio < clientRatio
        ? Math.round(this.clientRect.width) / this.videoWidth
        : Math.round(this.clientRect.height) / this.videoHeight;
    const videoOffsetX =
      videoRatio < clientRatio ? 0 : (this.clientRect.width - this.videoWidth * this._videoScale) * 0.5;
    const videoOffsetY =
      videoRatio < clientRatio ? (this.clientRect.height - this.videoHeight * this._videoScale) * 0.5 : 0;
    this._videoOriginX = this.clientRect.left + videoOffsetX;
    this._videoOriginY = this.clientRect.top + videoOffsetY;

    if (sendResize) {
      this.sendResizeMsg();
    }
  }

  resizeVideo() {
    this.updateVideoMetrics({ sendResize: true });

    // this.width = parseInt(this.clientRect.width);
    // this.height = parseInt(this.clientRect.height);
  }

  resizeVideo2() {
    this.waitForFullscreenResize(() => {
      this.resizeVideo();
    });
  }

  closeWindow() {
    this.stopVideoFrameWatch();
    if (this.pc) this.pc.close();
    if (this.ws) this.ws.close(1000);
  }

  getVideoFrameCount() {
    if (typeof this.getVideoPlaybackQuality === 'function') {
      return this.getVideoPlaybackQuality().totalVideoFrames ?? 0;
    }
    return this.webkitDecodedFrameCount ?? Math.floor((this.currentTime || 0) * 1000);
  }

  startVideoFrameWatch() {
    if (this.videoFrameWatchTimer) return;

    this.lastVideoFrameCount = this.getVideoFrameCount();
    this.lastVideoFrameChangedAt = Date.now();

    this.videoFrameWatchTimer = window.setInterval(() => {
      if (!this.isConnected) return;

      const frameCount = this.getVideoFrameCount();
      const now = Date.now();
      if (frameCount > this.lastVideoFrameCount) {
        this.lastVideoFrameCount = frameCount;
        this.lastVideoFrameChangedAt = now;
        return;
      }

      const recentlyInput = now - this.lastInputAt < 8000;
      const videoStalled = now - this.lastVideoFrameChangedAt > 3000;
      const canLog = now - this.lastVideoFrameStallLogAt > 5000;
      const connectionAlive =
        this.pc?.connectionState === 'connected' &&
        this.channelInput?.readyState === 'open' &&
        this.channelData?.readyState === 'open';

      if (!recentlyInput || !videoStalled || !canLog || !connectionAlive) return;

      this.lastVideoFrameStallLogAt = now;
      console.warn('[render-streaming] video frames stalled after input', {
        frameCount,
        lastVideoFrameCount: this.lastVideoFrameCount,
        msSinceInput: now - this.lastInputAt,
        msSinceFrameChanged: now - this.lastVideoFrameChangedAt,
        connectionState: this.pc?.connectionState,
        iceConnectionState: this.pc?.iceConnectionState,
        inputState: this.channelInput?.readyState,
        dataState: this.channelData?.readyState,
        wsState: this.ws?.readyState,
      });

      this.play().catch(error => console.warn('[render-streaming] video play retry failed:', error));
      this.sendResizeMsg();
    }, 1000);
  }

  stopVideoFrameWatch() {
    if (!this.videoFrameWatchTimer) return;
    window.clearInterval(this.videoFrameWatchTimer);
    this.videoFrameWatchTimer = null;
  }

  waitForFullscreenResize(callback) {
    let lastW = 0;
    let lastH = 0;
    let stableCount = 0;
    const _this = this;

    function check() {
      const w = _this.clientRect.width;
      const h = _this.clientRect.height;

      if (w === lastW && h === lastH) {
        stableCount++;
      } else {
        stableCount = 0;
        lastW = w;
        lastH = h;
      }

      // 连续 3 帧稳定，认为尺寸完成
      if (stableCount >= 30) {
        console.log(`width: ${_this.clientRect.width}, height: ${_this.clientRect.height}`);
        callback();
      } else {
        requestAnimationFrame(check);
      }
    }

    requestAnimationFrame(check);
  }

  async onWebSocketMessage(msg) {
    try {
      msg = JSON.parse(msg);
    } catch {
      console.debug('↓↓', msg);
      return;
    }
    console.log(`↓↓ ${msg.type}:`, msg);
    if (msg.type === 'offer' || msg.type === 'answer') {
      const desc = new RTCSessionDescription({ sdp: msg.data.sdp, type: msg.type });
      if (this.pc != null) {
        if (this.connectionId != msg.from) {
          return;
        }

        const isStable =
          this.pc.signalingState == 'stable' || (this.pc.signalingState == 'have-local-offer' && this.srdAnswerPending);
        this.ignoreOffer = desc.type == 'offer' && !this.polite && (this.makingOffer || !isStable);

        if (this.ignoreOffer) {
          console.log(`glare - ignoring offer`);
          return;
        }

        this.waitingAnswer = false;
        this.srdAnswerPending = desc.type == 'answer';
        console.log(`SRD(${desc.type})`);
        await this.pc.setRemoteDescription(desc);
        this.srdAnswerPending = false;

        if (desc.type == 'offer') {
          this.assert_equals(this.pc.signalingState, 'have-remote-offer', 'Remote offer');
          this.assert_equals(this.pc.remoteDescription.type, 'offer', 'SRD worked');
          console.log('SLD to get back to stable');
          await this.pc.setLocalDescription();
          this.assert_equals(this.pc.signalingState, 'stable', 'onmessage not racing with negotiationneeded');
          this.assert_equals(this.pc.localDescription.type, 'answer', 'onmessage SLD worked');
          this.ws.send(
            JSON.stringify({
              type: 'answer',
              from: this.connectionId,
              data: {
                sdp: this.pc.localDescription.sdp,
                connectionId: this.connectionId,
              },
            })
          );
        } else {
          this.assert_equals(this.pc.remoteDescription.type, 'answer', 'Answer was set');
          this.assert_equals(this.pc.signalingState, 'stable', 'answered');
        }

        for (let receiver of this.pc.getReceivers()) {
          receiver.playoutDelayHint = 0;
        }
      }
    } else if (msg.type === 'candidate') {
      const iceCandidate = new RTCIceCandidate({
        candidate: msg.data.candidate,
        sdpMid: msg.data.sdpMid,
        sdpMLineIndex: msg.data.sdpMLineIndex,
      });
      if (this.pc != null) {
        if (this.connectionId != msg.from) {
          return;
        }

        try {
          await this.pc.addIceCandidate(iceCandidate);
        } catch (e) {
          if (this.pc && !this.ignoreOffer)
            console.warn(`${this.pc} this candidate can't accept current signaling state ${this.pc.signalingState}.`);
        }
      }
    } else if (msg.type === 'ping') {
      this.ws.send(
        JSON.stringify({
          type: 'pong',
          from: this.connectionId,
          data: {},
        })
      );
    }
  }

  setupVideo() {
    this.tabIndex = 0; // easy to focus..
    // this.autofocus = true;
    this.playsInline = true;
    // this.disablepictureinpicture = true;

    // Recently many browsers can only autoplay the videos with sound off
    this.muted = true;
    // this.autoplay = true;

    this.clientRect = this.getBoundingClientRect();
    // this.width = parseInt(this.clientRect.width);
    // this.height = parseInt(this.clientRect.height);

    // this.onsuspend
    // this.onresize
    // this.requestPointerLock();

    // this.style["pointer-events"] = "none";
    // this.style["object-fit"] = "contain";

    this.oncontextmenu = e => {
      e.preventDefault();
      return false;
    };
  }

  setupInputChannel(e) {
    const _this = this;
    this.channelInput = this.pc.createDataChannel('input');
    this.channelInput.onopen = function () {
      console.log('✅Inputchannel connected.');
      // _this.style.pointerEvents = "auto";
    };
    this.channelInput.onerror = function (e) {
      console.log('The inputchannel error ' + e.error.message + ' occurred\n while handling data with proxy server.');
    };
    this.channelInput.onclose = function () {
      console.log('❌Inputchannel disconnected.');
      _this.channelInput = null;
      // _this.style.pointerEvents = "none";
      _this.blur();
    };
    this.channelInput.onmessage = async msg => {
      // receive message from unity and operate message
      let data;
      // receive message data type is blob only on Firefox
      if (navigator.userAgent.indexOf('Firefox') != -1) {
        data = await msg.data.arrayBuffer();
      } else {
        data = msg.data;
      }
      const bytes = new Uint8Array(data);
      if (bytes[0] == InputEvent.NoUnusedChannel) {
        console.warn('Unity has no usable channel');

        // 关闭数据通道
        try {
          _this.channelInput.close();
        } catch (e) {
          console.error('Close channelData error:', e);
        }

        if (_this.recreatingInput) return;
        _this.recreatingInput = true;

        // 启动延时重连（例如 3 秒）
        await _this.sleep(3000);

        if (_this.connectionId && _this.pc && !_this.channelInput) {
          console.log('try to create new input channel...');
          _this.setupInputChannel();
        }

        _this.recreatingInput = false;
      }
    };
  }

  setupDataChannel() {
    const _this = this;
    this.channelData = this.pc.createDataChannel('data');
    this.channelData.onopen = function () {
      console.log('✅Datachannel connected.');
      _this.pending = new Map();
      _this.lastSize = { width: 0, height: 0 };
      _this.sendResizeMsg();
    };
    this.channelData.onerror = function (e) {
      console.log('The datachannel error ' + e.error.message + ' occurred\n while handling data with proxy server.');
    };
    this.channelData.onclose = function () {
      console.log('❌Datachannel disconnected.');
      _this.pending = new Map();
      _this.lastSize = { width: 0, height: 0 };
      _this.channelData = null;
    };
    this.channelData.onmessage = async msg => {
      // receive message from unity and operate message
      let data;
      // receive message data type is blob only on Firefox
      if (navigator.userAgent.indexOf('Firefox') != -1) {
        data = await msg.data.arrayBuffer();
      } else {
        data = msg.data;
      }
      const bytes = new Uint8Array(data);
      if (bytes[0] == InputEvent.NoUnusedChannel) {
        console.warn('Unity has no usable channel');

        // 关闭数据通道
        try {
          _this.channelData.close();
        } catch (e) {
          console.error('Close channelData error:', e);
        }

        if (_this.recreatingData) return;
        _this.recreatingData = true;

        // 启动延时重连（例如 3 秒）
        await _this.sleep(3000);

        if (_this.connectionId && _this.pc && !_this.channelData) {
          console.log('try to create new data channel...');
          _this.setupDataChannel();
        }

        _this.recreatingData = false;
      } else if (bytes[0] == InputEvent.JsonData) {
        const jsonString = new TextDecoder('utf-8').decode(bytes.slice(1));
        const obj = JSON.parse(jsonString);
        // console.info('[render-streaming] unity json message received', obj);
        if (Debug) console.log(obj);

        if (obj.type == 'response') {
          const handler = _this.pending.get(obj.uuid);
          if (!handler) return;

          _this.pending.delete(obj.uuid);

          if (obj.success) {
            handler.resolve(obj.payload);
          } else {
            handler.reject(obj.error);
          }
        } else if (obj.type == 'notify') {
          const handler = this.pending.get(obj.uuid);
          if (handler?.onNotify) {
            handler.onNotify(obj.payload);
          } else {
            // console.info('[render-streaming] unity notify received', obj);
            _this.dispatchEvent(
              new CustomEvent(`unity_${obj.payload.type}`, {
                detail: { data: obj.payload.data, uuid: obj.uuid },
              })
            );
            _this.dispatchEvent(
              new CustomEvent(`unity-${obj.payload.type}`, {
                detail: { data: obj.payload.data, uuid: obj.uuid },
              })
            );
            window.dispatchEvent(new CustomEvent(obj.payload.type, { detail: obj.payload.data }));
          }
        } else if (obj.type == 'request') {
          console.info('[render-streaming] unity request received', obj);
          if (obj.payload?.type === 'getBlockRect') {
            _this.sendResponseMsg(obj.uuid, true, {
              type: 'getBlockRect',
              success: true,
            });
            _this
              .sendRequestMsg({
                type: 'setBlockRect',
                data: window.__UNITY_BLOCK_RECTS__ || [],
              })
              .catch(err => {
                console.error('[render-streaming] setBlockRect failed', err);
              });
          }
          _this.dispatchEvent(
            new CustomEvent(`unity_${obj.payload.type}`, {
              detail: { data: obj.payload.data, uuid: obj.uuid },
            })
          );
          _this.dispatchEvent(
            new CustomEvent(`unity-${obj.payload.type}`, {
              detail: { data: obj.payload.data, uuid: obj.uuid },
            })
          );
          window.dispatchEvent(new CustomEvent(obj.payload.type, { detail: obj.payload.data }));
        }
      }
    };
  }

  async setupPeerConnection() {
    this.pc.close();
    this.pc = new RTCPeerConnection();

    this.polite = true;
    this.ignoreOffer = false;
    this.makingOffer = false;
    this.waitingAnswer = false;
    this.srdAnswerPending = false;
    this.isClickingOutside = false;

    this.pc.ontrack = e => {
      console.log(`↓↓ ${e.track.kind} track:`, e);
      const tracks = this.localStream.getVideoTracks();
      for (const track of tracks) {
        if (track.kind == e.track.kind) {
          this.localStream.removeTrack(track);
        }
      }
      this.localStream.addTrack(e.track);
      this.play().catch(error => console.warn('video play failed after track received:', error));
      this.startVideoFrameWatch();
    };
    this.pc.onicecandidate = e => {
      // firefox
      if (e.candidate?.candidate) {
        console.log('↑↑ candidate:', e.candidate);
        this.ws.send(
          JSON.stringify({
            type: 'candidate',
            from: this.connectionId,
            data: {
              candidate: e.candidate.candidate,
              sdpMLineIndex: e.candidate.sdpMLineIndex,
              sdpMid: e.candidate.sdpMid,
              connectionId: this.connectionId,
            },
          })
        );
      } else {
        // Notice that the end of negotiation is detected here when the event"s candidate property is null.
      }
    };

    this.pc.ondatachannel = e => {
      console.log('datachannel:', e.channel);
    };

    this.pc.onnegotiationneeded = async () => {
      try {
        console.log(`SLD due to negotiationneeded`);
        this.assert_equals(this.pc.signalingState, 'stable', 'negotiationneeded always fires in stable state');
        this.assert_equals(this.makingOffer, false, 'negotiationneeded not already in progress');
        this.makingOffer = true;
        await this.pc.setLocalDescription();
        this.assert_equals(this.pc.signalingState, 'have-local-offer', 'negotiationneeded not racing with onmessage');
        this.assert_equals(this.pc.localDescription.type, 'offer', 'negotiationneeded SLD worked');
        this.waitingAnswer = true;
        this.ws.send(
          JSON.stringify({
            type: 'offer',
            from: this.connectionId,
            data: {
              sdp: this.pc.localDescription.sdp,
              connectionId: this.connectionId,
            },
          })
        );
      } catch (e) {
        console.error(e);
      } finally {
        this.makingOffer = false;
      }
    };

    this.pc.onsignalingstatechange = () => {
      console.log('signalingState changed:', this.pc.signalingState);
    };

    this.pc.oniceconnectionstatechange = () => {
      console.log('iceConnectionState changed:', this.pc.iceConnectionState);
      // if (this.pc.iceConnectionState === 'disconnected') {
      // this.pc.close();
      // this.ws.close(1000);
      // }
    };

    this.pc.onicegatheringstatechange = () => {
      console.log('iceGatheringState changed:', this.pc.iceGatheringState);
    };
    this.pc.onconnectionstatechange = () => {
      console.log('connectionState changed:', this.pc.connectionState);
      if (this.pc.connectionState == 'failed') {
        this.ws.close(1000);
      }

      if (this.pc.connectionState === 'connected') {
        this.dispatchEvent(new CustomEvent('rs-connected'));
      }

      if (
        this.pc.connectionState === 'disconnected' ||
        this.pc.connectionState === 'failed' ||
        this.pc.connectionState === 'closed'
      ) {
        this.dispatchEvent(new CustomEvent('rs-disconnected'));
      }
    };

    this.loopResendOffer();

    // 等待
    while (this.ws.readyState != 1) {
      await this.sleep(100);
    }
    this.setupInputChannel();
    this.setupDataChannel();
  }

  async loopResendOffer() {
    while (this.connectionId) {
      if (this.pc && this.waitingAnswer) {
        this.ws.send(
          JSON.stringify({
            type: 'offer',
            from: this.connectionId,
            data: {
              sdp: this.pc.localDescription.sdp,
              connectionId: this.connectionId,
            },
          })
        );
      }
      await this.sleep(this.interval);
    }
  }

  registerKeyboardEvents() {
    this.addEventListener('keyup', this.sendKeyUp, false);
    this.addEventListener('keydown', this.sendKeyDown, false);
  }

  unregisterKeyboardEvents() {
    this.removeEventListener('keyup', this.sendKeyUp, false);
    this.removeEventListener('keydown', this.sendKeyDown, false);
  }

  sendKeyUp(e) {
    const key = Keymap[e.code];
    const character = e.key.length === 1 ? e.key.charCodeAt(0) : 0;
    if (Debug) console.log('key down ' + key + ', repeat = ' + e.repeat + ', character = ' + character);
    this.sendInputMsg(new Uint8Array([InputEvent.Keyboard, KeyboardEventType.Up, e.repeat, key, character]).buffer);
  }

  sendKeyDown(e) {
    const key = Keymap[e.code];
    const character = e.key.length === 1 ? e.key.charCodeAt(0) : 0;
    if (Debug) console.log('key down ' + key + ', repeat = ' + e.repeat + ', character = ' + character);
    this.sendInputMsg(new Uint8Array([InputEvent.Keyboard, KeyboardEventType.Down, e.repeat, key, character]).buffer);
  }

  registerMouseEvents() {
    this.addEventListener('wheel', this.sendMouseWheel, false);
    this.addEventListener('pointerdown', this.sendPointerDownBubble, false);
    this.addEventListener('pointermove', this.sendPointerMoveBubble, false);
    this.addEventListener('pointerup', this.sendPointerUpBubble, false);
    this.addEventListener('pointercancel', this.sendPointerCancelBubble, false);
    this.addEventListener('click', this.sendClickBubble, false);

    document.addEventListener('pointerdown', this.mousedownCaptureBind);
    document.addEventListener('pointerup', this.mouseupCaptureBind);
    this.addEventListener('pointermove', this.mousemoveCapture, true);
  }

  unregisterMouseEvents() {
    this.removeEventListener('wheel', this.sendMouseWheel, false);
    this.removeEventListener('pointerdown', this.sendPointerDownBubble, false);
    this.removeEventListener('pointermove', this.sendPointerMoveBubble, false);
    this.removeEventListener('pointerup', this.sendPointerUpBubble, false);
    this.removeEventListener('pointercancel', this.sendPointerCancelBubble, false);
    this.removeEventListener('click', this.sendClickBubble, false);

    document.removeEventListener('pointerdown', this.mousedownCaptureBind);
    document.removeEventListener('pointerup', this.mouseupCaptureBind);
    this.removeEventListener('pointermove', this.mousemoveCapture, true);
  }

  sendTouch(e, phase) {
    this.updateVideoMetrics({ sendResize: false });
    const changedTouches = Array.from(e.changedTouches);
    const touches = Array.from(e.touches);
    const phrases = [];

    for (let i = 0; i < changedTouches.length; i++) {
      if (
        touches.find(function (t) {
          return t.identifier === changedTouches[i].identifier;
        }) === undefined
      ) {
        touches.push(changedTouches[i]);
      }
    }

    for (let i = 0; i < touches.length; i++) {
      touches[i].identifier;
      phrases[i] =
        changedTouches.find(function (e) {
          return e.identifier === touches[i].identifier;
        }) === undefined
          ? PointerPhase.Stationary
          : phase;
    }

    if (Debug)
      console.log(
        'touch phase:' +
          phase +
          ' length:' +
          changedTouches.length +
          ' pageX' +
          changedTouches[0].pageX +
          ', pageX: ' +
          changedTouches[0].pageY +
          ', force:' +
          changedTouches[0].force
      );

    let data = new DataView(new ArrayBuffer(2 + 13 * touches.length));
    data.setUint8(0, InputEvent.Touch);
    data.setUint8(1, touches.length);
    let byteOffset = 2;
    for (let i = 0; i < touches.length; i++) {
      const scale = this._videoScale * this._videoScale2;
      const originX = this._videoOriginX;
      const originY = this._videoOriginY;

      const x = (touches[i].pageX - originX) / scale;
      // According to Unity Coordinate system
      // const y = (touches[i].pageX - originY) / scale;
      const y = this.videoHeight / this._videoScale2 - (touches[i].pageY - originY) / scale;

      data.setInt32(byteOffset, touches[i].identifier, true);
      byteOffset += 4;
      data.setUint8(byteOffset, phrases[i]);
      byteOffset += 1;
      data.setInt16(byteOffset, x, true);
      byteOffset += 2;
      data.setInt16(byteOffset, y, true);
      byteOffset += 2;
      data.setFloat32(byteOffset, touches[i].force, true);
      byteOffset += 4;
    }
    this.sendInputMsg(data.buffer);
  }

  sendTouchMove(e) {
    this.sendTouch(e, PointerPhase.Moved);
    e.preventDefault();
  }

  sendTouchStart(e) {
    this.sendTouch(e, PointerPhase.Began);
    e.preventDefault();
  }

  sendTouchEnd(e) {
    this.sendTouch(e, PointerPhase.Ended);
    e.preventDefault();
  }

  sendTouchCancel(e) {
    this.sendTouch(e, PointerPhase.Canceled);
    e.preventDefault();
  }

  sendMouse(e) {
    this.updateVideoMetrics({ sendResize: false });
    const scale = this._videoScale * this._videoScale2;
    const originX = this._videoOriginX;
    const originY = this._videoOriginY;

    const x = (e.clientX - originX) / scale;
    // According to Unity Coordinate system
    // const y = (e.clientY - originY) / scale;
    const y = this.videoHeight / this._videoScale2 - (e.clientY - originY) / scale;

    if (Debug)
      console.log(
        'x: ' +
          x +
          ', y: ' +
          y +
          ', scale: ' +
          scale +
          ', originX: ' +
          originX +
          ', originY: ' +
          originY +
          ' mouse button:' +
          e.buttons
      );
    let data = new DataView(new ArrayBuffer(6));
    data.setUint8(0, InputEvent.Mouse);
    data.setInt16(1, x, true);
    data.setInt16(3, y, true);
    data.setUint8(5, e.buttons);
    this.sendInputMsg(data.buffer);
  }

  sendMouseWheel(e) {
    this.updateVideoMetrics({ sendResize: false });
    e.preventDefault();
    if (Debug) console.log('mouse wheel with delta ' + e.wheelDelta);
    let data = new DataView(new ArrayBuffer(9));
    data.setUint8(0, InputEvent.MouseWheel);
    data.setFloat32(1, e.deltaX, true);
    data.setFloat32(5, e.deltaY, true);
    this.sendInputMsg(data.buffer);
  }

  convertPointerToTouch(e) {
    return {
      changedTouches: [
        {
          identifier: e.pointerId,
          pageX: e.pageX,
          pageY: e.pageY,
          force: e.pressure || 1.0,
        },
      ],
      touches: [
        {
          identifier: e.pointerId,
          pageX: e.pageX,
          pageY: e.pageY,
          force: e.pressure || 1.0,
        },
      ],
    };
  }

  sendPointerDownBubble(e) {
    this.setPointerCapture(e.pointerId);

    if (e.pointerType === 'mouse') {
      this.sendMouse(e); // 调用你原来的 sendMouse()
    } else if (e.pointerType === 'touch') {
      this.sendTouchStart(this.convertPointerToTouch(e)); // 调用你原来的 sendTouchStart()
    }
  }

  sendPointerMoveBubble(e) {
    if (e.pointerType === 'mouse') {
      this.sendMouse(e); // 调用你原来的 sendMouse()
    } else if (e.pointerType === 'touch') {
      this.sendTouchMove(this.convertPointerToTouch(e)); // 调用你原来的 sendTouchMove()
    }
  }

  sendPointerUpBubble(e) {
    this.releasePointerCapture(e.pointerId);

    if (e.pointerType === 'mouse') {
      this.sendMouse(e); // 调用你原来的 sendMouse()
    } else if (e.pointerType === 'touch') {
      this.sendTouchEnd(this.convertPointerToTouch(e)); // 调用你原来的 sendTouchMove()
    }
  }

  sendPointerCancelBubble(e) {
    this.releasePointerCapture(e.pointerId);

    if (e.pointerType === 'touch') {
      this.sendTouchCancel(this.convertPointerToTouch(e));
    }
  }

  sendClickBubble(e) {
    this.updateVideoMetrics({ sendResize: false });
    const scale = this._videoScale * this._videoScale2;
    const originX = this._videoOriginX;
    const originY = this._videoOriginY;

    const x = (e.clientX - originX) / scale;
    // According to Unity Coordinate system
    // const y = (e.clientY - originY) / scale;
    const y = this.videoHeight / this._videoScale2 - (e.clientY - originY) / scale;

    if (Debug)
      console.log(
        'x: ' +
          x +
          ', y: ' +
          y +
          ', scale: ' +
          scale +
          ', originX: ' +
          originX +
          ', originY: ' +
          originY +
          ' mouse button:' +
          e.buttons
      );
    let data = new DataView(new ArrayBuffer(6));
    data.setUint8(0, InputEvent.Click);
    data.setInt16(1, x, true);
    data.setInt16(3, y, true);
    data.setUint8(5, e.buttons);
    this.sendInputMsg(data.buffer);
  }

  mousedownCapture(e) {
    if (!this.contains(e.target)) {
      this.isClickingOutside = true;
    }
  }

  mouseupCapture() {
    this.isClickingOutside = false;
  }

  mousemoveCapture(e) {
    if (this.isClickingOutside) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  }

  sendInputMsg(msg) {
    if (this.channelInput == null) return;

    switch (this.channelInput.readyState) {
      case 'connecting':
        console.log('Connection not ready');
        break;
      case 'open':
        this.lastInputAt = Date.now();
        this.channelInput.send(msg);
        break;
      case 'closing':
        console.log('Attempt to sendMsg message while closing');
        break;
      case 'closed':
        console.log('Attempt to sendMsg message while connection closed.');
        break;
    }
  }

  sendDataMsg(msg) {
    if (this.channelData == null) throw new Error('Connection not initiated');

    switch (this.channelData.readyState) {
      case 'connecting':
        throw new Error('Connection not ready');
        break;
      case 'open':
        this.channelData.send(msg);
        break;
      case 'closing':
        throw new Error('Attempt to sendMsg message while closing');
        break;
      case 'closed':
        throw new Error('Attempt to sendMsg message while connection closed.');
        break;
    }
  }

  sendResponseMsg(uuid, success, object) {
    const obj = {
      type: 'response',
      uuid,
      ts: Date.now(),
      success,
    };

    if (success) obj.payload = object;
    else obj.message = object;

    try {
      const requestText = JSON.stringify(obj);
      if (Debug) console.log(requestText);
      const dataBytes = new TextEncoder().encode(requestText);
      const bytesWithHeader = new Uint8Array(dataBytes.length + 1);
      bytesWithHeader[0] = InputEvent.JsonData;
      bytesWithHeader.set(dataBytes, 1);
      this.sendDataMsg(bytesWithHeader.buffer);
    } catch (err) {
      console.error(err.message);
    }
  }

  sendRequestMsg(payload, onNotify) {
    return new Promise((resolve, reject) => {
      const uuid = this.safeUUID();
      const obj = {
        type: 'request',
        uuid,
        ts: Date.now(),
        payload,
      };

      this.pending.set(uuid, { resolve, reject, onNotify });

      try {
        const requestText = JSON.stringify(obj);
        if (Debug) console.log(requestText);
        const dataBytes = new TextEncoder().encode(requestText);
        const bytesWithHeader = new Uint8Array(dataBytes.length + 1);
        bytesWithHeader[0] = InputEvent.JsonData;
        bytesWithHeader.set(dataBytes, 1);
        this.sendDataMsg(bytesWithHeader.buffer);
      } catch (err) {
        this.pending.delete(uuid);
        reject(err.message);
      }
    });
  }

  sendResizeMsg() {
    this.clientRect = this.getBoundingClientRect();
    this.lastSize = {
      width: Math.round(this.clientRect.width),
      height: Math.round(this.clientRect.height),
    };

    if (this.lastSize.width == 0 || this.lastSize.height == 0) return;

    this.sendRequestMsg({
      type: 'resize',
      data: {
        width: Math.round(this.clientRect.width),
        height: Math.round(this.clientRect.height),
      },
    })
      .then(data => {})
      .catch(err => {
        console.log(err);
      });
  }

  safeUUID() {
    return (
      crypto.randomUUID?.() ??
      ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
      )
    );
  }

  projectToWorld(coords) {
    const WORLD_SIZE = 1024000;
    const EARTH_RADIUS = 6371008.8;
    const DEG2RAD = Math.PI / 180;

    // Spherical mercator forward projection, re-scaling to WORLD_SIZE
    let x = -EARTH_RADIUS * DEG2RAD * coords[0] * (WORLD_SIZE / (EARTH_RADIUS * Math.PI * 2));
    let y =
      -EARTH_RADIUS *
      Math.log(Math.tan(Math.PI * 0.25 + 0.5 * DEG2RAD * coords[1])) *
      (WORLD_SIZE / (EARTH_RADIUS * Math.PI * 2));

    //z dimension, defaulting to 0 if not provided
    let z = 0;
    if (coords[2]) {
      let pixelsPerMeter = Math.abs(WORLD_SIZE / Math.cos(DEG2RAD * coords[1]) / (2 * Math.PI * EARTH_RADIUS));
      z = coords[2] * pixelsPerMeter;
    }

    const m = THREE_TO_UNITY;

    return [
      m[0] * x + m[4] * y + m[8] * z + m[12],
      m[1] * x + m[5] * y + m[9] * z + m[13],
      m[2] * x + m[6] * y + m[10] * z + m[14],
    ];
  }
}

if (!customElements.get('render-streaming')) {
  customElements.define('render-streaming', RenderStreaming, { extends: 'video' });
}

export const LabelType = {
  None: 0,
  Building: 1 << 0, // 1
  Vehicle: 1 << 1, // 2
  // 未来扩展
  // Pipe: 1 << 2,   // 4
  // Device: 1 << 3, // 8
  All: ~0, // -1 (全都选中)
};
